(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kopstorm-col"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionId = '{{ section_id }}';
  const container = document.querySelector(`#engineering-section-${sectionId}`);
  
  if (!container) return;
  
  const slider = container.querySelector('.engineering-features-slider');
  
  if (!slider) return;
  
  // Only handle mobile slider behavior if we're on mobile
  if (window.innerWidth <= 749) {
    initSlider();
  }
  
  // Re-initialize on resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 749) {
      initSlider();
    }
  });
  
  function initSlider() {
    const items = slider.querySelectorAll('.engineering-feature-image');
    if (items.length <= 1) return;
    
    // Center the slider initially
    if (items.length > 1) {
      setTimeout(() => {
        // If there are at least 3 items, scroll to the second item to show first one properly
        if (items.length >= 3) {
          const secondItem = items[1];
          const itemWidth = items[0].offsetWidth;
          const containerWidth = slider.offsetWidth;
          const scrollPosition = secondItem.offsetLeft - ((containerWidth - itemWidth) / 2);
          slider.scrollLeft = Math.max(0, scrollPosition - 15); // Adjust for padding
        } else {
          // For fewer items, just scroll a bit to show it's scrollable
          slider.scrollLeft = 10;
        }
      }, 100);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-collection-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionId = '{{ section_id }}';
  const container = document.querySelector(`#luggage-selector-${sectionId}`);
  
  if (!container) return;
  
  const slider = container.querySelector('.luggage-selector-grid');
  
  if (!slider) return;
  
  // Only initialize slider functionality on mobile
  if (window.innerWidth <= 767) {
    initSlider();
  }
  
  // Re-initialize on resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 767) {
      initSlider();
    }
  });
  
  function initSlider() {
    const items = slider.querySelectorAll('.luggage-selector-item');
    if (!items.length) return;
    
    // Calculate item width including gap
    const itemWidth = items[0].offsetWidth;
    const gap = parseInt('{{ section.settings.grid_gap_mobile }}');
    const itemFullWidth = itemWidth + gap;
    
    // Scroll to active item if it exists
    const activeItem = slider.querySelector('.luggage-selector-item--active');
    if (activeItem) {
      // Get the index of the active item
      const activeIndex = Array.from(items).indexOf(activeItem);
      
      // Center the active item
      const scrollPos = activeIndex * itemFullWidth - (slider.offsetWidth / 2) + (itemWidth / 2);
      
      // Use setTimeout to ensure this happens after initial layout
      setTimeout(() => {
        slider.scrollLeft = Math.max(0, scrollPos);
      }, 100);
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
